import { schema } from 'normalizr';
import { OrgNormalizer, LocationNormalizer, TransactionNormalizer } from '~/apps/shared/actions/normalize';

// TODO to shared folder

export const PaycodeNormalizer = new schema.Entity('paycodes', {
  'organization': OrgNormalizer,
  'location': LocationNormalizer,
  'transaction': TransactionNormalizer,
});
